var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000976562 49.9997C-0.000976562 22.3855 22.3848 -0.000244141 49.9991 -0.000244141C63.2598 -0.000244141 75.9776 5.26761 85.3544 14.6444C94.7311 24.0212 99.9989 36.739 99.9989 49.9997C99.9989 77.614 77.6133 99.9998 49.9991 99.9998C22.3848 99.9998 -0.000976562 77.614 -0.000976562 49.9997ZM40.8493 71.3999L69.9991 53.1998C71.09 52.5012 71.7498 51.2952 71.7498 49.9997C71.7498 48.7045 71.09 47.4983 69.9991 46.7999L40.7491 28.5998C39.5971 27.8734 38.1418 27.8288 36.9474 28.483C35.753 29.1374 35.0071 30.3878 34.9993 31.7498V68.2499C34.9831 69.6449 35.7427 70.9336 36.971 71.5949C38.1993 72.2564 39.6933 72.1812 40.8493 71.3999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play_button.c08ca40b8c7d39677a0428a9537cb71f.svg";
export { ForwardRef as ReactComponent };